import gql from 'graphql-tag'

import { PublicExpoCurrentEventQuery } from '../../../types/api'

export const currentEvent = {
  query: gql`
    query publicExpoCurrentEvent($locale: String) {
      publicExpoCurrentEvent(locale: $locale) {
        uuid
        slug
        name
        description
        registration_closing_at
        frontTitle
        frontDescription
        frontImage
        locales {
          id
          label
          iso
        }
        slots {
          id
          bookable
          opening_hour
          closing_hour
          remaining_capacity
          event {
            id
            uuid
            name
            slug
          }
        }
      }
    }
  `,
  transformer: (response: PublicExpoCurrentEventQuery) => {
    return response.publicExpoCurrentEvent
  },
}
